
    module.exports = {
      render: function(){with(this){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(active),expression:"active"}],staticClass:"checkbox-panel"},[_t("default")],2)}},
      staticRenderFns: []
    };
  